import * as React from 'react';

import { useMapContext } from '../../../context';
import { ZoomInButton } from './ZoomInButton';

export const ZoomInButtonContainer: React.FC = props => {
  const { map } = useMapContext();

  return <ZoomInButton {...props} map={map} />;
};
